import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('Error:', error);
    console.log('Error Info:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center font-bold font-BTitr text-xl text-secondary h-screen">
          مشکلی پیش آمده است، لطفا صفحه را بروزرسانی نمایید.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
